module.exports = __webpack_public_path__ + "static/livechat-5e0d6b69e2a41b7851c3f8ace8081e5b.png";